import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BenutzermanagementAPIService } from '../../api/benutzermanagement/benutzermanagement-api.service';

@Component({
  selector: 'san-versorgen-statt-sparen',
  imports: [],
  templateUrl: './versorgen-statt-sparen.component.html',
  styleUrl: './versorgen-statt-sparen.component.scss',
})
export class VersorgenStattSparenComponent {
  static readonly ID = 'versorgen-statt-sparen';

  constructor(
    private activeModal: NgbActiveModal,
    private bmClient: BenutzermanagementAPIService,
  ) {}

  alsWeggeklicktMarkieren() {
    this.activeModal.dismiss();
    this.bmClient
      .setPopupViewed(VersorgenStattSparenComponent.ID, true)
      .subscribe();
  }

  alsGelesenMarkieren() {
    this.activeModal.dismiss();
    this.bmClient
      .setPopupViewed(VersorgenStattSparenComponent.ID, false)
      .subscribe();
  }
}
